"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _system = require("@/api/system");
var _default = exports.default = {
  data: function data() {
    var validatePassword = function validatePassword(rule, value, callback) {
      if (value.length < 6) {
        callback(new Error('Password must be at least 6 digits'));
      } else {
        callback();
      }
    };
    return {
      pwdBox: false,
      form: {
        oldPwd: '',
        newPwd: ''
      },
      formRules: {
        oldPwd: [{
          required: true,
          message: this.$t('form.oldPasswordNotEmpty')
        }, {
          required: true,
          trigger: 'blur',
          validator: validatePassword
        }],
        newPwd: [{
          required: true,
          message: this.$t('form.newPasswordNotEmpty')
        }, {
          required: true,
          trigger: 'blur',
          validator: validatePassword
        }],
        confirmPwd: {
          required: true,
          message: this.$t('form.confirmPasswordNotEmpty')
        }
      },
      confirmPwd: ''
    };
  },
  methods: {
    confirm: function confirm() {
      var _this = this;
      this.$refs['form'].validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(valid) {
          var _yield$editAdminPwd, code;
          return (0, _regenerator2.default)().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!(_this.confirmPwd !== _this.form.newPwd)) {
                  _context.n = 1;
                  break;
                }
                _this.$message.error(_this.$t('form.passwordEnterError'));
                return _context.a(2, false);
              case 1:
                _context.n = 2;
                return (0, _system.editAdminPwd)(_this.form);
              case 2:
                _yield$editAdminPwd = _context.v;
                code = _yield$editAdminPwd.code;
                if (code === 0) {
                  _this.$message({
                    message: _this.$t('form.editSuccess'),
                    type: 'success'
                  });
                  _this.pwdBox = false;
                  _this.form = {
                    oldPwd: '',
                    newPwd: ''
                  };
                }
              case 3:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};